import Vue from 'vue'
import VueRouter from 'vue-router'

import jwtService from '../plugins/jwt.service'
import auth from '../middlewares/auth'
import log from '../middlewares/log'
import store from '@/store/index.js';


Vue.use(VueRouter)

const routes = [

    {
        path: '/',
        name: 'Home',
        component: () =>
            import('../views/Home.vue')
    },
    {
        // AI auto-confirm quality report (admin-only; the page redirects non-admins)
        path: '/autoconfirm/quality',
        name: 'autoConfirmQuality',
        component: () =>
            import('../views/autoconfirm/quality.vue'),
        props: true
    },
    {
        path: '/createstore',
        name: 'createStore',
        component: () =>
            import('../views/storeino_store.vue'),
        props: true
    },
    {
        path: '/profil',
        name: 'Home',
        component: () =>
            import('../views/profil.vue')
    },


    /*********************************************************************/

    {
        path: '/sourcings',
        name: 'sourcings',
        component: () =>
            import('../views/sourcings/index.vue'),
        props: true
    },
    {
        path: '/sourcings/new',
        name: 'newSourcing',
        component: () =>
            import('../views/sourcings/form.vue'),
        props: true
    },
    {
        path: '/sourcings/edit/:id',
        name: 'updateSourcing',
        component: () =>
            import('../views/sourcings/form.vue'),
        props: true
    },
    {
        path: '/sourcings/detail/:id',
        name: 'viewSourcings',
        component: () =>
            import('../views/sourcings/view.vue')
    },



    /*********************************************************************/



    
    {
        path: '/users',
        name: 'users',
        component: () =>
            import('../views/users/index.vue'),
        props: true
    },
    {
        path: '/users/edit/:id',
        name: 'updateUser',
        component: () =>
            import('../views/users/form.vue'),
        props: true
    },
    {
        path: '/users/new',
        name: 'newUser',
        component: () =>
            import('../views/users/form.vue'),
        props: true
    },
    {
        path: '/users/history',
        name: 'historyUser',
        component: () =>
            import('../views/users/history.vue'),
        props: true
    },
    {
        path: '/roles',
        name: 'roles',
        component: () =>
            import('../views/roles/index.vue'),
        props: true
    },
    {
        path: '/roles/new',
        name: 'newRole',
        component: () =>
            import('../views/roles/form.vue'),
        props: true
    },
    {
        path: '/roles/edit/:id',
        name: 'updateRole',
        component: () =>
            import('../views/roles/form.vue'),
        props: true
    },

    {
        path: '/teams',
        name: 'teams',
        component: () =>
            import('../views/teams/index.vue'),
        props: true
    },
    {
        path: '/teams/new',
        name: 'newTeam',
        component: () =>
            import('../views/teams/form.vue'),
        props: true
    },
    {
        path: '/teams/edit/:id',
        name: 'updateTeam',
        component: () =>
            import('../views/teams/form.vue'),
        props: true
    },

    /***********************************************************************/
    {
        path: '/products',
        name: 'products',
        component: () =>
            import('../views/products/index.vue'),
        props: true
    },
    {
        path: '/products/new',
        name: 'newProduct',
        component: () =>
            import('../views/products/form.vue'),
        props: true
    },
    {
        path: '/products/edit/:id',
        name: 'updateProduct',
        component: () =>
            import('../views/products/form.vue')
    },
    {
        path: '/products/detail/:id',
        name: 'viewProduct',
        component: () =>
            import('../views/products/view.vue')
    },
    {
        path: '/products/variants/:id',
        name: 'productVariants',
        component: () =>
            import('../views/products/variants.vue'),
        props: true
    },
    /***********************************************************************/
    {
        path: '/warehouses',
        name: 'warehouses',
        component: () =>
            import('../views/warehouses/index.vue'),
        props: true
    },
    {
        path: '/warehouses/new',
        name: 'newWarehouse',
        component: () =>
            import('../views/warehouses/form.vue'),
        props: true
    },
    {
        path: '/warehouses/edit/:id',
        name: 'updateWarehouse',
        component: () =>
            import('../views/warehouses/form.vue')
    },
    /***********************************************************************/
    {
        path: '/categories',
        name: 'categories',
        component: () =>
            import('../views/categories/index.vue'),
        props: true
    },
    {
        path: '/categories/new',
        name: 'newCategory',
        component: () =>
            import('../views/categories/form.vue'),
        props: true
    },
    {
        path: '/categories/edit/:id',
        name: 'updateCategory',
        component: () =>
            import('../views/categories/form.vue')
    },
    {
        path: '/categories/detail/:id',
        name: 'viewCategory',
        component: () =>
            import('../views/categories/view.vue')
    },
    /***********************************************************************/

    {
        path: '/orders',
        name: 'orders',
        component: () =>
            import('../views/orders/index.vue'),
        props: true
    },
    {
        path: '/orders/new',
        name: 'newOrder',
        component: () =>
            import('../views/orders/form.vue'),
        props: true
    },
    {
        path: '/orders/edit/:id',
        name: 'updateOrder',
        component: () =>
            import('../views/orders/form.vue')
    },
    {
        path: '/orders/detail/:id',
        name: 'viewOrder',
        component: () =>
            import('../views/orders/view.vue')
    },
    {
        path: '/orders/import',
        name: 'importOrders',
        component: () =>
            import('../views/orders/importOrders.vue'),
    },
    {
        path: '/orders/api',
        name: 'apiCreateOrders',
        component: () =>
            import('../views/orders/api.vue'),
    },

    {
        path: '/senders',
        name: 'senders',
        component: () => import('../views/senders/index.vue'),
        props: true,
    },
    {
        path: '/orders/confirmation',
        name: 'confirmation',
        component: () =>
            import('../views/callcenter/confirmation.vue'),
        props: true
    },
    /***********************************************************************/
    {
        path: '/expeditions',
        name: 'expeditions',
        component: () =>
            import('../views/expeditions/index.vue'),
        props: true
    },
    {
        path: '/expeditions/new',
        name: 'newExpedition',
        component: () =>
            import('../views/expeditions/form.vue'),
        props: true
    },
    {
        path: '/expeditions/edit/:id',
        name: 'updateExpedition',
        component: () =>
            import('../views/expeditions/form.vue')
    },
    {
        path: '/expeditions/detail/:id',
        name: 'viewExpedition',
        component: () =>
            import('../views/expeditions/view.vue')
    },
    /********************************************************************** */
    {
        path: '/status',
        name: 'status',
        component: () =>
            import('../views/status/index.vue'),
        props: true
    },
    {
        path: '/status/new',
        name: 'newStatus',
        component: () =>
            import('../views/status/form.vue'),
        props: true
    },
    {
        path: '/status/edit/:id',
        name: 'updateStatus',
        component: () =>
            import('../views/status/form.vue')
    },
    {
        path: '/status/detail/:id',
        name: 'viewStatus',
        component: () =>
            import('../views/status/view.vue')
    },
    /********************************************************************* */
    {
        path: '#',
        name: 'Shipping order',
        component: () =>
            import('../views/zones/index.vue'),
        props: false
    },
    {
        path: '/zones',
        name: 'zones',
        component: () =>
            import('../views/zones/index.vue'),
        props: true
    },
    {
        path: '/zones/new',
        name: 'newZones',
        component: () =>
            import('../views/zones/form.vue'),
        props: true
    },
    {
        path: '/zones/edit/:id',
        name: 'updateZones',
        component: () =>
            import('../views/zones/form.vue')
    },
    /********************************************************************* */
    {
        path: '/shippings',
        name: 'shippings',
        component: () =>
            import('../views/shippings/index.vue'),
        props: true
    },
    {
        path: '/shippings/edit/:id',
        name: 'updateShippings',
        component: () =>
            import('../views/shippings/form.vue')
    },
    {
        path: '/shippings/view/:id',
        name: 'viewOrder',
        component: () =>
            import('../views/shippings/view.vue')
    },
    /***********************************************************************/
    {
        path: '/subscribers',
        name: 'subscribers',
        component: () =>
            import('../views/subscribers/index.vue'),
        props: true
    },
    {
        path: '/subscribers/new',
        name: 'newSubscribers',
        component: () =>
            import('../views/subscribers/form.vue'),
        props: true
    },
    {
        path: '/subscribers/edit/:id',
        name: 'updateSubscribers',
        component: () =>
            import('../views/subscribers/form.vue')
    },
    {
        path: '/subscribers/detail/:id',
        name: 'viewSubscribers',
        component: () =>
            import('../views/subscribers/view.vue')
    },
    {
        path: '/callcenter',
        name: 'callcenter',
        component: () =>
            import('../views/callcenter/analytics.vue'),
        props: true
    },

    {
        path: '/callcenter/analytics/view/:id',
        name: 'viewanalytics',
        component: () =>
            import('../views/callcenter/viewGraph.vue')
    },
    {
        path: '/callcenter/analytics/viewStatus/:id',
        name: 'viewStatus',
        component: () =>
            import('../views/callcenter/viewStatus.vue')
    },


    /********************************************************************* */
    {
        path: '#',
        name: 'Payments',
        component: () =>
            import('../views/payments/index.vue'),
        props: false
    },
    {
        path: '/payments',
        name: 'payments',
        component: () =>
            import('../views/payments/index.vue'),
        props: true
    },
    {
        path: '/payments/new',
        name: 'newPayments',
        component: () =>
            import('../views/payments/form.vue'),
        props: true
    },
    {
        path: '/payments/detail/:id',
        name: 'viewpayment',
        component: () =>
            import('../views/payments/view.vue')
    },
    {
        path: '/balances/requests',
        name: 'balancesRequests',
        component: () =>
            import('../views/balances/requests.vue'),
        props: true
    },
    {
        path: '/ma-balance',
        name: 'myBalance',
        component: () =>
            import('../views/balances/myBalance.vue'),
        props: true
    },
    {
        path: '/affiliations',
        name: 'affiliations',
        component: () =>
            import('../views/affiliations/index.vue'),
        props: true
    },
    {
        path: '/wallets',
        name: 'wallets',
        component: () =>
            import('../views/balances/wallets.vue'),
        props: true
    },
    {
        path: '/settings',
        name: 'settings',
        component: () =>
            import('../views/settings/form.vue'),
        props: true
    },
    /********************************************************************* */
    {
        path: '/charges',
        name: 'charges',
        component: () =>
            import('../views/charges/index.vue'),
        props: true
    },
    {
        path: '/charges/new',
        name: 'newCharge',
        component: () =>
            import('../views/charges/form.vue'),
        props: true
    },
    {
        path: '/charges/edit/:id',
        name: 'updateCharge',
        component: () =>
            import('../views/charges/form.vue'),
        props: true
    },


    {
        path: '/affiliates/offers',
        name: 'offers',
        component: () =>
            import('../views/affiliates/offers/index.vue'), 
        props: true
    },
    {
        path: '/affiliates/offers/:id',
        name: 'viewOffre',
        component: () =>
            import('../views/affiliates/offers/view.vue')
    },
    {
        path: '/affiliates/requests',
        name: 'requestOffres',
        component: () =>
            import('../views/affiliates/index.vue'),
        props: true
    },
    {
        path: '/affiliates/analytics',
        name: 'affiliatesAnalytics',
        component: () => import('../views/Home.vue'),
        props: true
    },



    {
        path: "/marketplaces/products",
        name: "marketplaces",
        component: () => import("../views/marketplaces/products/index.vue"),
        props: true,
      },
      {
        path: "/marketplaces/products/:id",
        name: "view_offer",
        component: () => import("../views/marketplaces/products/view.vue"),
        meta: { groupParent: "marketplaces" },
      },
      {
        path: "/marketplaces/requests",
        name: "request_offer",
        component: () => import("../views/marketplaces/index.vue"),
        meta: { groupParent: "marketplaces" },
        props: true,
      },
      {
        path: "/marketplaces/demands",
        name: "demands_product",
        component: () => import("../views/marketplaces/demands/index.vue"),
        meta: { groupParent: "marketplaces" },
        props: true,
      },
    //   {
    //     path: "/marketplaces/payments",
    //     name: "marketplace_payments",
    //     component: () => import("../views/marketplaces/payments/index.vue"),
    //     meta: { groupParent: "marketplaces" },
    //     props: true,
    //   },
    

    /********************************************************************* */
    // Partners (COD Platforms)
    {
        path: '/partners',
        name: 'partners',
        component: () => import('../views/partners/index.vue'),
        props: true
    },
    {
        path: '/partners/new',
        name: 'newPartner',
        component: () => import('../views/partners/form.vue'),
        props: true
    },
    {
        path: '/partners/edit/:id',
        name: 'updatePartner',
        component: () => import('../views/partners/form.vue'),
        props: true
    },
    {
        path: '/partners/view/:id',
        name: 'viewPartner',
        component: () => import('../views/partners/view.vue'),
        props: true
    },

    /********************************************************************* */
    // Integrations - YouCan
    {
        path: '/integrations/youcan',
        name: 'youcanIntegration',
        component: () => import('../views/integrations/youcan/index.vue'),
        props: true
    },

    /********************************************************************* */
    // Seller Team Management
    {
        path: '/seller-team',
        name: 'sellerTeam',
        component: () => import('../views/seller-team/index.vue'),
        props: true
    },
    {
        path: '/seller-team/new',
        name: 'newSellerTeamMember',
        component: () => import('../views/seller-team/form.vue'),
        props: true
    },
    {
        path: '/seller-team/edit/:id',
        name: 'editSellerTeamMember',
        component: () => import('../views/seller-team/form.vue'),
        props: true
    },

    /********************************************************************* */
    // Agent Dashboard - Shipping Follow-up System
    {
        path: '/agent-dashboard',
        name: 'agentDashboard',
        component: () => import('../views/agent-dashboard/Index.vue'),
        props: true
    },

    /********************************************************************* */
    // Agent Assignments Management (for Managers)
    {
        path: '/agent-assignments',
        name: 'agentAssignments',
        component: () => import('../views/agent-assignments/Index.vue'),
        props: true
    },

    /********************************************************************* */
    // Account Manager Routes
    {
        path: '/account-manager',
        name: 'accountManagerDashboard',
        component: () => import('../views/account-manager/Dashboard.vue'),
        props: true
    },
    {
        path: '/account-manager/sellers',
        name: 'accountManagerSellers',
        component: () => import('../views/account-manager/SellersList.vue'),
        props: true
    },
    {
        path: '/account-manager/sellers/:id',
        name: 'accountManagerSellerStats',
        component: () => import('../views/account-manager/SellerStats.vue'),
        props: true
    },
    {
        path: '/account-manager/chat',
        name: 'accountManagerChat',
        component: () => import('../views/account-manager/ChatPage.vue'),
        props: true
    },
    {
        path: '/account-manager/chat/:conversationId',
        name: 'accountManagerChatConversation',
        component: () => import('../views/account-manager/ChatPage.vue'),
        props: true
    },
    {
        path: '/account-manager/alerts',
        name: 'accountManagerAlerts',
        component: () => import('../views/account-manager/Alerts.vue'),
        props: true
    },
    // Admin Account Managers Management
    {
        path: '/admin/account-managers',
        name: 'adminAccountManagers',
        component: () => import('../views/admin/AccountManagers.vue'),
        props: true
    },
    // Seller Chat Route
    {
        path: '/chat',
        name: 'sellerChat',
        component: () => import('../views/account-manager/ChatPage.vue'),
        props: true
    },
    {
        path: '/chat/:conversationId',
        name: 'sellerChatConversation',
        component: () => import('../views/account-manager/ChatPage.vue'),
        props: true
    },

    /********************************************************************* */
    // Stockist Dashboard Routes (for StockManager)
    {
        path: '/stockist-dashboard',
        name: 'stockistDashboard',
        component: () => import('../views/stockist-dashboard/Index.vue'),
        props: true
    },
    {
        path: '/stockist-dashboard/assign',
        name: 'stockistAssign',
        component: () => import('../views/stockist-dashboard/AssignPackages.vue'),
        props: true
    },
    {
        path: '/stockist-dashboard/returns',
        name: 'stockistReturns',
        component: () => import('../views/stockist-dashboard/ConfirmReturns.vue'),
        props: true
    },
    {
        path: '/stockist-dashboard/stats',
        name: 'stockistStats',
        component: () => import('../views/stockist-dashboard/MyStats.vue'),
        props: true
    },
    {
        path: '/stockist-dashboard/couriers',
        name: 'stockistCouriers',
        component: () => import('../views/stockist-dashboard/MyCouriers.vue'),
        props: true
    },

    { path: '*', redirect: '/' }


]



const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})


router.beforeEach((to, from, next) => {
    // redirect to login page if not logged in and trying to access a restricted page
    //const { log } = to.meta;

    //check profil seller/partner complet (rib + fullName + payout method) sinon redirect vers /profil
    const u = store.state.user;
    const paymentMethodIncomplete = (user) => {
        const pm = user && user.paymentMethod;
        if (!pm || !pm.type) return true;
        if (['payoneer', 'wise'].includes(pm.type)) return !pm.email;
        if (pm.type === 'usdt') return !pm.walletAddress;
        if (pm.type === 'bank') return !pm.bankName || !pm.rib;
        return true;
    };
    if (u && u.type && ['Seller', 'Partner', 'Fournisseur'].includes(u.type)
        && (!u.rib || !u.fullName || paymentMethodIncomplete(u))
        && to.path !== '/profil') {
        window.location.href = '/profil';
        return;                                // ma-nkemmelوش l-navigation
    }

    // Pages CEO dyal balances INTERDITES l'Seller/Partner (widget dyalهom kafي) — redirect l'/
    const balancesCeoRoutes = ['balancesRequests', 'wallets'];
    if (u && u.type && ['Seller', 'Partner', 'Fournisseur'].includes(u.type) && to.name && balancesCeoRoutes.includes(to.name)) {
        return next('/');
    }

    // /ma-balance réservée au Fournisseur uniquement
    if (to.name === 'myBalance' && (!u || u.type !== 'Fournisseur')) {
        return next('/');
    }

    // Fournisseur: /payments => /ma-balance
    if (u && u.type === 'Fournisseur' && to.name && ['payments', 'Payments', 'newPayments', 'viewpayment'].includes(to.name)) {
        return next('/ma-balance');
    }

    // Fournisseur: orders, shippings, admin, sourcing, opérations INTERDITES — redirect l'/profil
    const fournisseurBlockedRoutes = [
        'orders', 'newOrder', 'updateOrder', 'viewOrder', 'importOrders', 'apiCreateOrders', 'confirmation',
        'shippings', 'updateShippings',
        'users', 'newUser', 'updateUser', 'historyUser', 'roles', 'newRole', 'updateRole', 'teams', 'newTeam', 'updateTeam',
        'status', 'newStatus', 'updateStatus', 'viewStatus', 'zones', 'newZones', 'updateZones', 'senders',
        'sourcings', 'newSourcing', 'updateSourcing', 'viewSourcings',
        'subscribers', 'newSubscribers', 'updateSubscribers', 'viewSubscribers',
        'callcenter', 'viewanalytics',
    ];
    if (u && u.type === 'Fournisseur' && to.name && fournisseurBlockedRoutes.includes(to.name)) {
        return next('/profil');
    }

    // Charges INTERDITE l'Seller/Partner/Fournisseur — redirect l'/profil
    const chargesRoutes = ['charges', 'newCharge', 'updateCharge'];
    if (u && u.type && ['Seller', 'Partner', 'Fournisseur'].includes(u.type) && to.name && chargesRoutes.includes(to.name)) {
        return next('/profil');
    }

    
    if(to && to.name){

        if(from && from.name && (from.name === 'Home' && to.name === 'affiliatesAnalytics') || (from.name === 'affiliatesAnalytics' && to.name === 'Home')){
            window.location.href = to.name === 'Home'?'/':'/affiliates/analytics?typeOrder='+(to.query && to.query.typeOrder || 'affiliate');
        }

        store.dispatch("modelupdate",{ model:to.name });
    } 

    next();
})

export default router